var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent image main"},[_c('img',{attrs:{"alt":"Stream Cover","src":_vm.stream.cover}}),(_vm.stream.avatar)?_c('RTAvatar',{staticClass:"avatar",attrs:{"size":_vm.size,"img":_vm.stream.avatar}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }